import { useMutation } from "react-query";
import api from "../../client";
import { AuthResetPasswordPayload } from "../../types/auth";

const postData = async (payload: AuthResetPasswordPayload): Promise<[]> => {
  const { data } = await api.post(`/reset-password/forgot-password`, payload);

  return data;
};

export const useResetPassword = () => {
  return useMutation((payload: AuthResetPasswordPayload) => {
    return postData(payload);
  });
};
